<style>
    #SubMenu .sideImg{
        width:1rem;
        height: 1rem;
        margin-right:1rem;
    }
</style>
<template>
    <a-sub-menu id="SubMenu" :key="menuInfo.menuid" v-bind="$props" v-on="$listeners">
        <span slot="title">
            <span>
				<!-- <img class="sideImg" :src="colorKey == menuInfo.sort ? sideListOnImgArr[menuInfo.sort] : sideListImgArr[menuInfo.sort]"> -->
				<img class="sideImg" :src="colorKey == menuInfo.menuid ? menuInfo.openpic: menuInfo.closepic">
				{{ menuInfo.title }}</span>
        </span>
        <template v-for="item in menuInfo.secondLevel">
            <a-menu-item v-if="!item.secondLevel" :key="item.menuid" :title='""||item.url'>
                <router-link style="color:inherit;" @click.native="changeSideBol(item)" :to="item.url">
                    <span>{{item.title}}</span> 
                </router-link>
            </a-menu-item>
            <sub-menu v-else :key="item.menuid" :menu-info="item"/>
        </template>
    </a-sub-menu>
	<!-- <a-sub-menu id="SubMenu" :key="menuInfo.key" v-bind="$props" v-on="$listeners">
	    <span slot="title">
	        <span><img class="sideImg" :src="colorKey == menuInfo.key ? sideListOnImgArr[menuInfo.key] : sideListImgArr[menuInfo.key]">{{ menuInfo.title }}</span>
	    </span>
	    <template v-for="item in menuInfo.children">
	        <a-menu-item v-if="!item.children" :key="item.key">
	            <router-link style="color:inherit;" @click.native="changeSideBol(item)" :to="item.url">
	                <span>{{item.title}}</span> 
	            </router-link>
	        </a-menu-item>
	        <sub-menu v-else :key="item.key" :menu-info="item"/>
	    </template>
	</a-sub-menu> -->
</template>
<script>

    import sideListImg01 from '../../image/icon_shouye.png';
    import sideListImg11 from '../../image/icon_jiaoyi.png';
    import sideListImg21 from '../../image/icon_houtai.png';
    import sideListImg31 from '../../image/icon_shangcheng.png';

    import sideListImg02 from '../../image/icon_shouye1.png';
    import sideListImg12 from '../../image/icon_jiaoyi1.png';
    import sideListImg22 from '../../image/icon_houtai1.png';
    import sideListImg32 from '../../image/icon_shangcheng1.png';
    
    export default {
        name: 'SubMenu',
        props: {
            menuInfo: {
                type: Object,
                default: () => ({}),
            },
            sideBol:{
                type: Boolean,
                default: () => ({}),
            },
            colorKey:{
                // type: String,
                default: () => ({}),
            }
        },
        watch: {
            colorKey(newVal){
                this.colorKey = newVal;
            }
        },
		mounted() {
			
		},
        data(){
            return{
                sideListImgArr : ['',sideListImg01,sideListImg11,sideListImg21,sideListImg31],
                sideListOnImgArr : ['',sideListImg02,sideListImg12,sideListImg22,sideListImg32]
            }
        },
        methods:{
            changeSideBol(val){
				console.log(val)
				if(val.menu_level > 1){//菜单 二级
					this.$store.commit('handtitle',val)
				}
                this.$emit("changeSideBol",false)
            }
        }
    }
</script>